import React from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { ProgressBar } from "../../components/ui/ProgressBar";
import { ProfileCard } from "../../components/ui/ProfileCard";

export const ProfilPage: React.FC = () => {
  return (
    <Layout>
      <Container className="py-6">
        <div className="relative mx-auto grid h-full w-full grid-cols-1 items-start justify-center">
          <ProgressBar />
          <main className="flex-1 py-4 sm:py-6 md:py-8">
            <ProfileCard />
          </main>
        </div>
      </Container>
    </Layout>
  )
}


